<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업체</h5>
          <vs-button class="ml-4 py-2 px-4" color="secondary" @click="onClick433">근로자 수 집계하기</vs-button>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>사업장명</div>
          <ml-input v-model="form.inputA_1" :readonly="true" />
        </div>
        <div>
          <div>업종 또는<br/>주요 생산품명</div>
          <ml-input v-model="form.inputA_2" :readonly="board.readonly"/>
        </div>
        <div>
          <div>소재지</div>
          <ml-input v-model="form.inputA_3" :readonly="board.readonly"/>
        </div>
        <div>
          <div>남성 근로자 수(명)</div>
          <ml-input v-model="form.inputA_4" :readonly="board.readonly" type="number" @input="validateInput"/>
        </div>
        <div>
          <div>여성 근로자 수(명)</div>
          <ml-input v-model="form.inputA_5" :readonly="board.readonly" type="number" @input="validateInput"/>
        </div>
        <div>
          <div>총 근로자 수(명)</div>
          <ml-input v-model="form.inputA_6"  :readonly="true" type="number " :value="totalWorkers"/>
        </div>
        <div>
          <div>전화번호</div>
          <ml-input v-model="form.inputA_7" :readonly="board.readonly"/>
        </div>
      </div>

      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 선임대상</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-3 flex items-center"
             v-for="(checkbox, checkIndex) in form.targetList"
             v-bind:key="checkbox.id"
        >
          <div v-if="isPrint || board.readonly" class="flex">
            <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ checkbox.label }}
          </div>
          <label v-else class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="checkbox.check">
            </vs-checkbox>
            {{ checkbox.label }}
          </label>
        </div>
      </div>

      <div v-for="(checkbox, checkIndex) in form.targetList"
           v-bind:key="checkbox.id">
        <div v-if="checkbox.check">
          <vs-row class="mt-8 mb-4">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
              <h5><i class="dot"></i> {{ checkbox.title }}</h5>
            </vs-col>
          </vs-row>
          <div class="writeGridContainer">
            <div>
              <div>성명</div>
              <ml-input v-model="checkbox.data.name" :readonly="board.readonly"
                        @input="(value) => handleAdmin(checkbox.id, value)"/>
            </div>
            <div>
              <div>기관명</div>
              <ml-input v-model="checkbox.data.company" :readonly="board.readonly"/>
            </div>
            <div>
              <div>전자우편 주소</div>
              <ml-input v-model="checkbox.data.email" :readonly="board.readonly"/>
            </div>
            <div>
              <div>전화번호</div>
              <ml-input v-model="checkbox.data.phone" :readonly="board.readonly"/>
            </div>
            <div>
              <div>자격/면허번호</div>
              <ml-input v-model="checkbox.data.licenseCode" :readonly="board.readonly"/>
            </div>
          </div>
          <table-custom
            :board="board"
            :is-print="isPrint"
            :controls="false"
            :multiple="false"
            v-model="checkbox.data.list"
            :tableData="[
              { id: 'input1', title: '경력 - 기관명', type: 'text', placeholder: '내용' },
              { id: 'input2', title: '경력 - 기간', type: 'dateArr' },
            ]"
          />
          <div class="writeGridContainer">
            <div>
              <div>학력 - 학교</div>
              <ml-input v-model="checkbox.data.educationLevel" :readonly="board.readonly"/>
            </div>
            <div>
              <div>학력 - 학과</div>
              <ml-input v-model="checkbox.data.major" :readonly="board.readonly"/>
            </div>
            <div>
              <div>선임일</div>
              <date-selector v-model="checkbox.data.assignmentDate" :readonly="board.readonly" />
            </div>
            <div>
              <div>구분</div>
              <vs-select
                v-model="checkbox.data.type"
                autocomplete
                :disabled="board.readonly"
                class="w-full flex-1"
              >
                <vs-select-item text="전담" value="전담" />
                <vs-select-item text="겸임" value="겸임" />
              </vs-select>
            </div>
          </div>

        </div>
      </div>

      <vs-row class="mt-8 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 보고인</h5>
        </vs-col>
      </vs-row>
      <div class="mb-4">「산업안전보건법 시행규칙」 제14조제2항에 따라 위와 같이 보고서를 제출합니다.</div>
      <div class="writeGridContainer">
        <div>
          <div>사업주 또는 대표자</div>
          <ml-input v-model="form.inputB_1" :readonly="board.readonly"/>
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.inputB_2" :readonly="board.readonly"/>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
  <print v-else :form="form" />
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import SignField from "@/components/SignField.vue";
import Print from "./Print.vue";
import * as DataUtil from "@/util/DataUtil";

export default {
  components: {
    Print,
    SignField,
    TableCustom,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    totalWorkers() {
      let sum = Number(this.form.inputA_4) + Number(this.form.inputA_5)
      if (sum < 0) {
        sum = 0
        this.form.inputA_4 = Math.max(this.form.inputA_4, 0)
        this.form.inputA_5 = Math.max(this.form.inputA_5, 0)
      }

      this.form.inputA_6 = sum
      return sum
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.stdInfo': {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 = this.form.stdInfo.field_name
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: 0,
        inputA_5: 0,
        inputA_6: 0,
        inputA_7: '',

        inputB_1: '',
        inputB_2: '',

        admin1: '',
        admin2: '',
        admin3: '',

        targetList: [
          {
            id: 1,
            check: false,
            label: '안전관리자',
            title: '안전관리자(안전관리 대행기관)',
            data: {
              name: '',
              company: '',
              email: '',
              phone: '',
              licenseCode: '',
              list: [
                {input1: '', input2: {sDate: '', eDate: ''}},
                {input1: '', input2: {sDate: '', eDate: ''}},
              ],
              educationLevel: '',
              major: '',
              assignmentDate: '',
              type: '',
            }
          },
          {
            id: 2,
            check: false,
            label: '보건관리자',
            title: '보건관리자(보건관리 대행기관)',
            data: {
              name: '',
              company: '',
              email: '',
              phone: '',
              licenseCode: '',
              list: [
                {input1: '', input2: {sDate: '', eDate: ''}},
                {input1: '', input2: {sDate: '', eDate: ''}},
              ],
              educationLevel: '',
              major: '',
              assignmentDate: '',
              type: '',
            }
          },
          {
            id: 3,
            check: false,
            label: '산업보건의',
            title: '산업보건의',
            data: {
              name: '',
              company: '',
              email: '',
              phone: '',
              licenseCode: '',
              list: [
                {input1: '', input2: {sDate: '', eDate: ''}},
                {input1: '', input2: {sDate: '', eDate: ''}},
              ],
              educationLevel: '',
              major: '',
              assignmentDate: '',
              type: '',
            }
          }
        ]
      },
    };
  },
  methods: {
    validateInput() {
      if (this.form.inputA_4 < 0) {
        this.form.inputA_4 = 0
      }
      if (this.form.inputA_5 < 0) {
        this.form.inputA_5 = 0
      }
    },
    handleAdmin(num, value) {
      if (num === 1) this.form.admin1 = value
      else if(num === 2) this.form.admin2 = value
      else if(num === 3) this.form.admin3 = value
    },

    async onClick433 () {
      const employeeList = await DataUtil.loadDefragmentation(this.$store, "board/LOAD_POST_LIST", {
        projectId: this.projectId,
        boardId: 433,
        page: 1,
        perPage: 100,
        conditions: [
          { key: "body.retirement_date", operator: ">n", value: new Date().format("yyyy-MM-dd")}
        ]
      }, true)

      this.form.inputA_4 = 0
      this.form.inputA_5 = 0
      employeeList.map(item => {
        const body = JSON.parse(item.post_content).body

        if (`${body.gender}` === "남" || `${body.enc.gender}` === "남") this.form.inputA_4 += 1
        else if (`${body.gender}` === "여" || `${body.enc.gender}` === "여") this.form.inputA_5 += 1

        return {
          id: item.id,
          full_name: body.enc.full_name,
          gender: body.gender || body.enc.gender,
        }
      })

    }
  },
};
</script>

<style scoped lang="scss">
</style>
